import firedux from '../firedux'

import {
  CONVERSATION_MESSAGE_COUNTS_ENDPOINT
} from '../../config/constants'

const incrementMessageCount = (count) => {
  if (typeof(count) !== 'number' || count < 0) count = 0

  return count + 1
}

export default (containerId) => {
  const ref = firedux.ref.child(CONVERSATION_MESSAGE_COUNTS_ENDPOINT).child(containerId)

  return ref.transaction(incrementMessageCount)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/increment_total_message_count.js
 **/